document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".js-link");

  function handleLink(event) {
    event.preventDefault();
    const link = event.currentTarget;
    let url;
    switch (link.getAttribute("data-url-type")) {
      case "hotellist_spec":
        url = hotellistSpecUrl(link);
        break;
      case "hotellist_location":
        url = hotellistLocationUrl(link);
        break;
      case "hotellist":
        url = hotellistUrl();
        break;
    }
    if (url?.trim()) {
      openUrl(url, link.getAttribute("data-target"));
    }
  }

  function hotellistSpecUrl(link) {
    const location_type = link.getAttribute("data-location-type");
    const location_id = link.getAttribute("data-location-id");
    const spec_id = link.getAttribute("data-spec-id");
    const lid = link.getAttribute("data-lid");
    return `/hotellist-${location_type}-${location_id}-${spec_id}?lid=${lid}`;
  }

  function hotellistLocationUrl(link) {
    const location_type = link.getAttribute("data-location-type");
    const location_id = link.getAttribute("data-location-id");
    return `/hotellist-${location_type}-${location_id}`;
  }

  function hotellistUrl() {
    return "/hotellist";
  }

  function openUrl(url, target) {
    target === "true" ? window.open(url, "_blank", "noopener") : (window.location.href = url);
  }

  links.forEach((link) => {
    link.addEventListener("click", handleLink);
  });
});
